<mat-toolbar class="nav" color="primary">
    <button type="button" class="menuButton visible-sm no-print" mat-icon-button style="z-index: 1;"
        (click)="toggleSidebar()" exceptclick>
        <mat-icon aria-label="Side nav toggle icon" exceptclick>menu</mat-icon>
    </button>
    <span class="nav-spacer no-print"></span>
    <div class="profile hide-sm">
        <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start">
            <div fxFlex="10" fxLayoutAlign="start start" class="no-print" style="height: 100%;">
                <button type="button" class="menuButton" mat-icon-button style="z-index: 1;" (click)="toggleSidebar()"
                    exceptclick>
                    <mat-icon aria-label="Side nav toggle icon" exceptclick>menu</mat-icon>
                </button>
                <div class="nav-brand" title="{{subTitle | translate}}" exceptclick fxLayout="row" fxLayoutGap="0.5vw"
                    fxLayoutAlign="center center">
                    <!-- <img fxFlex id="topNavLogo" src="assets/images/logo.png"
                        class="circle z-depth-2 responsive-img activator" alt="{{title | translate}}"
                        (click)="toggleSidebar()"> -->
                    <!-- <div fxFlex class="userPrefecture"
                        [ngStyle]="{'font-family': languageSelected === 'en' ? 'arial': 'serif'}" *ngIf="selectedUser">
                        {{prefecture}}</div> -->
                    <div fxFlex class="userPrefectureSmall">
                        <img class="logo" [src]="loginLogoSrc" [alt]="prefecture" (click)="openHomePage()" />
                    </div>
                    <div fxFlex class="userPrefecture">
                        <img *ngIf="loginLogoSrc" class="logo" [src]="loginLogoSrc" [alt]="prefecture"
                            (click)="openHomePage()" />
                    </div>
                    <!-- <div fxFlex class="userPrefecture"
                        [ngStyle]="{'font-family': languageSelected === 'en' ? 'arial': 'serif'}">
                        {{prefecture}}</div> -->
                    <img fxFlex *ngIf="!(selectedUser && selectedUser.prefecture)" [src]="topLogoSrc"
                        (click)="toggleSidebar()" />
                </div>
            </div>
            <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
            <div class="notification-icon">
                <mat-icon (click)="showNotifications()" [matMenuTriggerFor]="notificationsMenu"
                    #notificationsMenuTrigger="matMenuTrigger" [matTooltip]="'Notifications' | translate"
                    [class.active-notification]="unreadNotificationsNumber">{{unreadNotificationsNumber ?
                    'notifications_active' : 'notifications' }}</mat-icon>
                <mat-icon class="chat-notification-icon" (click)="openUnReadDialog()"
                    [matTooltip]="'Unread chats' | translate" [class.active-notification]="unreadNumber">
                    chat_bubble
                </mat-icon>
                <mat-menu #notificationsMenu="matMenu" class="notifications-menu-panel"
                    overlayPanelClass="notifications-menu-overlay">
                    <div matMenuContent (click)="$event.stopPropagation()" class="notifications-menu-content">
                        <div class="notifications-top-nav-box">
                            <div class="notifications-menu-header">
                                {{'Notifications' | translate}}
                            </div>
                            <div *ngIf="notificationsLoading" class="notifications-empty">
                                {{'Loading' | translate}}...
                            </div>
                            <div *ngIf="notificationsLoaded && !notificationsList?.length" class="notifications-empty">
                                {{'No Data Available' | translate}}.
                            </div>
                            <div fxLayout="column" fxLayoutGap="0" class="topnav-notification-item"
                                *ngFor="let notification of notificationsList;let i =index"
                                [class.active]="notification.isActive" (click)="viewNotification(notification)"
                                [ngClass]="'item-' + (i % 2)">
                                <div fxFlex fxLayout="row" fxLayoutGap="1vh">
                                    <div fxFlex="70" fxGrow="1" fxLayout="column" fxLayoutGap="1vh">
                                        <div fxFlex class="detail" fxGrow="0">
                                            <span *ngIf="notification.type == 'threat'">
                                                {{ notification.threat_type | enum: threatTypeEnum }}
                                                {{'at' | translate }}
                                                {{notification.location}}
                                            </span>
                                            <span *ngIf="notification.type == 'dispatched-threat'">
                                                <ng-container
                                                    *ngFor="let threatType of notification.threat_types; let last = last">
                                                    {{ threatType | enum: threatTypeEnum }}<span *ngIf="!last">,
                                                    </span>
                                                </ng-container>.
                                                {{'Field Investigators notified to go to' | translate }}
                                                {{notification.location}}
                                            </span>
                                            <span
                                                *ngIf="notification.type == 'note' || notification.type == 'alert' || notification.type == 'LPR'">
                                                {{'New note added to case' | translate}}
                                                {{notification.case?.case_id}}<span *ngIf="notification.note?.name">:
                                                    {{notification.note.name}}</span>
                                            </span>
                                            <span *ngIf="notification.type == 'init'">
                                                {{'Added case' | translate}}<span *ngIf="notification.case?.name">
                                                    {{notification.case.name}}</span> {{notification.case?.case_id}}
                                                {{notification.createdAt | date: 'yy-MM-dd HH:mm'}}
                                            </span>
                                            <span *ngIf="notification.type == 'annotation'">
                                                {{'Annotation added to' | translate}}: {{notification.case?.case_id}}
                                            </span>
                                            <span *ngIf="notification.type == 'whiteboard'">
                                                {{'Whiteboard added to' | translate}}: {{notification.case?.case_id}}
                                            </span>
                                            <span *ngIf="notification.type == 'material'">
                                                {{'Material added to' | translate}}: {{notification.case?.case_id}}
                                            </span>
                                            <span *ngIf="notification.type == 'case'">
                                                {{'Case Assigned' | translate}}<span
                                                    *ngIf="notification.case && notification.case.case_id">:
                                                    {{notification.case.case_id}}</span>
                                            </span>
                                            <span *ngIf="notification.type == 'missedcall'">
                                                {{'Missed call from' | translate:{ name: notification.user?.name } }}
                                            </span>
                                            <span *ngIf="notification.document?.type == 'video'">
                                                <div fxLayout="column">
                                                    <span fxFlex
                                                        *ngIf="notification.document.name">{{notification.document.name}}</span>
                                                    <span fxFlex class="document-type">{{'Video' | translate}}</span>
                                                </div>
                                            </span>
                                            <span *ngIf="notification.document?.type == 'audio'">
                                                <div fxLayout="column">
                                                    <span fxFlex
                                                        *ngIf="notification.document.name">{{notification.document.name}}</span>
                                                    <span fxFlex class="document-type">{{'Audio' | translate}}</span>
                                                </div>
                                            </span>
                                            <span *ngIf="notification.document?.type == 'file'">
                                                <div fxLayout="column">
                                                    <span fxFlex
                                                        *ngIf="notification.document.name">{{notification.document.name}}</span>
                                                    <span fxFlex class="document-type">{{'Document' | translate}}</span>
                                                </div>
                                            </span>
                                            <span *ngIf="notification.document?.type == 'image'">
                                                <div fxLayout="column">
                                                    <span fxFlex
                                                        *ngIf="notification.document.name">{{notification.document.name}}</span>
                                                    <span fxFlex class="document-type">{{'Image' | translate}}</span>
                                                </div>
                                            </span>
                                            <span *ngIf="notification.type == 'location'">
                                                {{'Investigators sent to location' | translate}}
                                            </span>
                                            <span *ngIf="notification.type == 'status'">
                                                {{'Case status changed to' | translate}} '{{notification.case?.status |
                                                enum:
                                                statusEnum}}'
                                            </span>
                                        </div>
                                        <div fxFlex class="description">
                                            <span
                                                *ngIf="notification.type == 'note' || notification.type == 'alert' || notification.type == 'status' || notification.type == 'location'">
                                                {{notification.description}}
                                            </span>
                                            <span *ngIf="notification.type == 'init' || notification.type == 'status'">
                                                {{notification.case?.description}}
                                            </span>
                                            <span *ngIf="notification.type == 'location'">
                                                {{'Investigators' | translate}} {{notification.sentToInvestigators}}
                                                {{'notified to go to' | translate}}
                                                {{notification.location}}
                                            </span>
                                        </div>
                                    </div>
                                    <div fxFlex="30" fxGrow="0" fxLayout="column" fxLayoutGap="0vh" align="right">
                                        <div fxFlex class="time">
                                            {{notification.createdTimeAgo}}
                                        </div>
                                        <div fxFlex class="createdBy">
                                            {{notification.createdName}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="notifications-menu-actions">
                            <button mat-button type="button" (click)="goNotifications()">
                                {{'View All' | translate}}
                            </button>
                            <button mat-raised-button type="button" class="green-text"
                                [disabled]="!unreadNotifications?.length && !notificationsList?.length"
                                (click)="markAllNotificationsAsRead()">
                                {{'Mark all as read' | translate}}
                            </button>
                        </div>
                    </div>
                </mat-menu>
            </div>
            <div class="hide-sm picture-role no-print" [matMenuTriggerFor]="userMenu" #menuTrigger="matMenuTrigger">
                <div fxFlex fxLayout="column" fxGrow="0" fxLayoutAlign="center center">
                    <div class="profile-container">
                        <img fxFlex [src]="pictureLink || 'assets/images/profile.png'"
                            [class.role-border-red]="role == 'Admin' || selectedUser?.['isAdmin']"
                            [class.role-border-green]="role == 'Field Investigator'"
                            [class.role-border-orange]="role == 'Command Center Investigator' && !selectedUser?.['isAdmin']"
                            [class.role-border-black]="role == 'Technician'"
                            class="circle-img-btn z-depth-2 responsive-img activator"
                            (error)="$event.target.src='assets/images/profile.png'" />
                    </div>
                    <div fxFlex fxGrow="0" class="role">
                        {{selectedUser?.alternative_name || '' }}
                        <!-- {{selectedUser.lastName}} {{selectedUser.firstName}} -->
                    </div>
                </div>
                <mat-menu #userMenu="matMenu" class="user-menu">
                    <div matMenuContent (click)="$event.stopPropagation()">
                        <div fxLayout="column" fxLayoutGap="0" class="user-menu-content">
                            <div fxFlex fxLayout="column" fxLayoutGap="0" class="top-section">
                                <div fxFlex fxLayoutAlign="center center">
                                    <div class="user-image">
                                        <img [src]="pictureLink || 'assets/images/profile.png'"
                                            class="circle-img-btn z-depth-2 responsive-img activator"
                                            (error)="$event.target.src='assets/images/profile.png'" />
                                        <mat-icon (click)="editProfileImage()" class="edit"
                                            [matTooltip]="'Edit' | translate">edit
                                        </mat-icon>
                                    </div>
                                </div>
                                <div fxFlex fxGrow="0" fxLayoutAlign="center center" class="name">
                                    {{selectedUser?.lastName || ''}} {{selectedUser?.firstName || ''}}
                                </div>
                                <div fxFlex fxGrow="0" class="role" fxLayoutAlign="center center">
                                    <span style="text-align: center;">
                                        {{role | translate}} <span style="margin-left:5px"
                                            *ngIf="selectedUser?.['isAdmin']">
                                            ({{'Admin' | translate}})</span>
                                    </span>
                                </div>
                                <div fxFlex fxGrow="0" class="badge" fxLayoutAlign="center center"
                                    *ngIf="selectedUser?.badge_no">
                                    {{selectedUser.badge_no | translate}}
                                </div>
                                <div fxFlex fxGrow="0" fxLayoutAlign="center center" class="email"
                                    *ngIf="selectedUser?.email">
                                    {{selectedUser.email}}
                                </div>
                                <div fxFlex fxGrow="0" fxLayoutAlign="center center" class="email"
                                    *ngIf="selectedUser?.phone">
                                    {{selectedUser.phone}}
                                </div>
                            </div>
                            <div fxFlex fxGrow="0" *ngIf="unreadNumber">
                                <div (click)="openUnReadDialog()" class="clickable">
                                    <mat-icon style="color:red">chat_bubble</mat-icon> {{unreadNumber}}
                                    <ng-container *ngIf="unreadNumber == 1">{{'unread message' |
                                        translate}}</ng-container>
                                    <ng-container *ngIf="unreadNumber > 1">{{'unread messages' |
                                        translate}}</ng-container>
                                    <!-- <ng-container *ngIf="!unread.length">
                                        <mat-icon>chat_bubble</mat-icon> {{unread.length}} {{'unread messages' | translate}}
                                    </ng-container>                                     -->
                                </div>
                            </div>
                            <div fxFlex fxGrow="0" *ngIf="unreadNotificationsNumber">
                                <div (click)="openUnReadNotificationsDialog()" class="clickable">
                                    <mat-icon *ngIf="unreadNotificationsNumber"
                                        style="color:red">notifications_active</mat-icon>
                                    <mat-icon *ngIf="!unreadNotificationsNumber">notifications</mat-icon>
                                    <span *ngIf="unreadNotificationsNumber">{{unreadNotificationsNumber}} </span>
                                    <ng-container *ngIf="unreadNotificationsNumber == 1">{{'unread notifications' |
                                        translate}}</ng-container>
                                    <ng-container *ngIf="unreadNotificationsNumber > 1">{{'unread notifications' |
                                        translate}}</ng-container>
                                    <!-- <ng-container *ngIf="unreadNotificationsNumber == 0">{{'Notifications' |
                                        translate}}</ng-container> -->
                                </div>
                            </div>
                            <div fxFlex fxGrow="0">
                                <div (click)="saveDnd()" class="clickable">
                                    <mat-icon>{{isDnd ? 'do_not_disturb_on': 'do_not_disturb_off'}}</mat-icon>
                                    <span *ngIf="isDnd">{{'DND on' |
                                        translate}}</span>
                                    <span *ngIf="!isDnd">{{'DND off' |
                                        translate}}</span>
                                </div>
                            </div>
                            <div fxFlex fxGrow="0" *ngIf="enableSurveillance">
                                <div (click)="toggleMuteSound()" class="clickable">
                                    <mat-icon>{{isThreatMuted ? 'volume_off': 'volume_up'}}</mat-icon>
                                    <span *ngIf="isThreatMuted">{{'Unmute Alert Sound' |
                                        translate}}</span>
                                    <span *ngIf="!isThreatMuted">{{'Mute Alert Sound' |
                                        translate}}</span>
                                </div>
                            </div>
                            <div fxFlex fxGrow="0">
                                <div (click)="editProfile()" class="clickable">
                                    <mat-icon>edit</mat-icon> <span>{{'Edit Profile' | translate}}</span>
                                </div>
                            </div>
                            <div fxFlex>
                                <div (click)="changePassword()" class="clickable">
                                    <mat-icon>lock_reset</mat-icon> <span>{{'Change Password' | translate}}</span>
                                </div>
                            </div>
                            <div fxFlex>
                                <div (click)="callLogs()" class="clickable">
                                    <img src="assets/images/icon/call_log_default.svg"
                                        style="width: 16px;vertical-align: middle;margin-right: 10px;" /> <span>{{'Call
                                        Logs' | translate}}</span>
                                </div>
                            </div>
                            <!-- <div fxFlex>
                                <div (click)="askSupport()" class="clickable">
                                    <mat-icon>help</mat-icon> <span>{{'Help' | translate}}</span>
                                </div>
                            </div> -->
                            <div fxFlex *ngIf="((languageSelection && langs.length > 1) || isSuperAdmin) ">
                                <div (click)="changeLanguage()" class="clickable">
                                    <mat-icon>language</mat-icon> <span
                                        *ngIf="languageSelected === 'en'">Language/言語</span>
                                    <span *ngIf="languageSelected === 'ja'">言語/Language</span>
                                </div>
                            </div>
                            <div fxFlex>
                                <div (click)="onLoggedout()" class="clickable">
                                    <mat-icon>logout</mat-icon> <span>{{'Logout' | translate}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-menu>
            </div>
            <div class="topnav-actions no-print">
                <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                    [matTooltip]="'More Actions' | translate">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionsMenu="matMenu" class="user-menu topnav-actions-menu">
                    <button mat-menu-item type="button" *ngIf="isCaseDashboardPage" (click)="toggleResetView()">
                        <mat-icon class="material-symbols-outlined">reopen_window</mat-icon>
                        <span>{{'Reset View' | translate}}</span>
                    </button>
                    <button mat-menu-item type="button" (click)="toggleFullscreen()">
                        <mat-icon class="material-symbols-outlined">
                            {{isFullscreen ? 'close_fullscreen' : 'fullscreen'}}
                        </mat-icon>
                        <span>{{(isFullscreen ? 'Exit fullscreen' : 'Full Screen') | translate}}</span>
                    </button>
                </mat-menu>
            </div>
        </div>
        <!-- <mat-form-field class="language hide-sm">
            <mat-label>{{'Language' | translate}}</mat-label>
            <mat-select name="select-clients" (selectionChange)="changeLang($event.value)" [value]="languageSelected">
                <mat-option value="en">English</mat-option>
                <mat-option value="ja">日本語</mat-option>
            </mat-select>
        </mat-form-field> -->
        <!-- <span class="date">{{date | date : "EEEE" | translate }}, {{date | date : "MMMM" | translate }} {{date |
            date : "d, y" | translate }}</span> -->
        <!-- <button mat-icon-button [matMenuTriggerFor]="notificationsMenu" (click)="handleMenuOpened()"
            class="notifications-menu-button" [class.has-new]="hasNew">
            <mat-icon>notifications</mat-icon>
        </button> -->
        <!-- <mat-menu #notificationsMenu="matMenu">
        <div class="notifications-top-nav-box">

            <div *ngIf="!notificationsLoaded" style="text-align: center;">
                <mat-spinner diameter="30" style="margin: auto;"></mat-spinner>
            </div>

            <div *ngIf="!notificationsList.length && notificationsLoaded">
                <p style="text-align: center;">No notifications yet</p>
            </div>

            <span *ngIf="notificationsList.length && notificationsLoaded">
                <div *ngFor="let item of notificationsList">
                    <button mat-menu-item [class.notification-badge]="item.viewed == false"
                        (click)="viewNotification(item)" style="font-size: 14px;">{{item.title}}</button>
                </div>
            </span>
        </div>
        <div>
            <button mat-menu-item
                style="width:35%; float: left; padding: 0px; margin-right: 0px; text-align: center;line-height: 35px; height: 35px;"
                (click)="moveToNotificationsPage()">View All</button>
            <button mat-menu-item color="primary"
                style="width:Calc(65% - 5px); padding: 0px; float: left; text-align: center; background-color: #32A5D7; color: #ffffff;line-height: 35px; height: 35px;"
                (click)="markAllAsRead()">Mark all as read</button>
        </div>
    </mat-menu> -->
        <!-- <button mat-icon-button [routerLink]="[]" title="{{'My Profile' |translate}}" [matMenuTriggerFor]="profileMenu">
            <mat-icon style="font-size: 40px;line-height: 40px;height: 40px;width: 40px;"
                *ngIf="!pictureLink || pictureLink === ''">account_circle</mat-icon>
            <img *ngIf="pictureLink && pictureLink !== ''" [src]="pictureLink"
                class="circle-img-btn z-depth-2 responsive-img activator"  (error)="$event.target.src='assets/images/profile.png'">
        </button>
        <mat-menu #profileMenu="matMenu">
            <div class="profile-top-nav-box">
                <button mat-menu-item (click)="viewProfile()" style="font-size: 14px;">{{'Profile' | translate}}
                </button>
                <button mat-menu-item (click)="changeLanguage()" style="font-size: 14px;">
                    <ng-container *ngIf="languageSelected == 'en'">
                        Language/言語
                    </ng-container>
                    <ng-container *ngIf="languageSelected == 'ja'">
                        言語/Language
                    </ng-container>
                </button>
                <button mat-menu-item (click)="onLoggedout()" style="font-size: 14px;">{{'Logout' | translate}}
                </button>
            </div>
        </mat-menu> -->
        <!-- <div class="profile-menu" [matMenuTriggerFor]="profileMenu">

            <div class="dr-name">{{selectedUser.firstName}}</div>

            <button mat-icon-button>
                <mat-icon>expand_more</mat-icon>
            </button>
            <mat-menu #profileMenu="matMenu">
                <div class="profile-top-nav-box">
                    <button mat-menu-item (click)="viewProfile()" style="font-size: 14px;">Profile
                    </button>

                    <button mat-menu-item (click)="onLoggedout()" style="font-size: 14px;">Logout
                    </button>
                </div>
            </mat-menu>
        </div> -->
    </div>
</mat-toolbar>